
interface LoadingOverlayProps {
  message: string;
}

/**
 * Loading overlay shown during AI scene generation.
 */
export function LoadingOverlay({ message }: LoadingOverlayProps) {
  return (
    <div className="absolute inset-0 bg-sands-900/15 backdrop-blur-sm flex items-center justify-center z-20 animate-fade-in">
      <div className="text-center bg-white/95 backdrop-blur-sm border border-sands-200 rounded-2xl px-8 py-6 shadow-lg">
        <div className="relative w-16 h-16 mx-auto mb-4">
          {/* Animated rings */}
          <div className="absolute inset-0 border-2 border-sands-300 rounded-full animate-ping opacity-30" />
          <div className="absolute inset-2 border-2 border-sands-400 rounded-full animate-ping opacity-40 animation-delay-200" />
          <div className="absolute inset-4 border-2 border-sands-500 rounded-full animate-pulse" />
        </div>
        <p className="text-sands-800 font-medium">{message}</p>
        <p className="text-sands-600 text-sm mt-1">
          This usually takes a few seconds
        </p>
      </div>
    </div>
  );
}
